import { useCallback, useMemo } from 'react';
import { useContactSupportModal } from './Context';
import useSteps from 'components/WizardForm/useSteps';

export const useContactSupport = () => {
  const { isOpen, closeModal } = useContactSupportModal();
  const { step, setStep, goToNextStep, goToPrevStep } = useSteps(1);

  const handleClose = useCallback(() => {
    setStep(1);
    closeModal();
  }, [setStep, closeModal]);

  const title = useMemo(
    () =>
      step === 2
        ? 'Contact your Condominium Board or Management'
        : 'Who would you like to contact?',
    [step]
  );

  return {
    isOpen,
    step,
    goToNextStep,
    goToPrevStep,
    title,
    handleClose,
  };
};
